export class AdditionalItemForPrescriptionReleaseStruct {
    public idItem: number;
    public idStorage: number;
    public numberOfItens: number;

    public itemName: string;
    public itemCode: string;
    public storageBatch: string;
    public locationName: string;
}